<div class="search-results-page">
    <div class="container py-8">
        <!-- Search Summary Header Bar -->
        <div class="search-summary-card mb-6">
            <div class="summary-left">
                <a routerLink="/customer-portal" class="back-link">
                    <mat-icon class="back-icon">arrow_back</mat-icon>
                    {{ 'CUSTOMER_PAGE.BACK_TO_SEARCH' | transloco }}
                </a>
                <h1 class="page-main-title">{{ 'CUSTOMER_PAGE.SELECT_YOUR_PARKING' | transloco }}</h1>
                <p class="page-sub-title">{{ 'CUSTOMER_PAGE.COMPARE_PARKING_OPTIONS' | transloco }}</p>
            </div>
            <div class="summary-info-pill" *ngIf="fromDate && toDate">
                <div class="info-item">
                    <span class="info-label">{{ 'CUSTOMER_PAGE.AIRPORT' | transloco }}</span>
                    <strong class="info-val">{{ airport === 'skavsta' ? 'Skavsta Airport' : 'Arlanda Airport'
                        }}</strong>
                </div>
                <div class="info-divider"></div>
                <div class="info-item">
                    <span class="info-label">{{ 'CUSTOMER_PAGE.PARKING_PERIOD' | transloco }}</span>
                    <strong class="info-val">{{ fromDate | date:'yyyy-MM-dd HH:mm' }} &rarr; {{ toDate |
                        date:'yyyy-MM-dd HH:mm' }}</strong>
                </div>
            </div>
        </div>

        <!-- Filter Options Bar -->
        <div class="filters-bar-card mb-6" *ngIf="!isLoading">
            <div class="filter-header-row">
                <span class="filter-bar-title">
                    <mat-icon class="filter-icon">tune</mat-icon>
                    {{ 'CUSTOMER_PAGE.FILTER_OPTIONS' | transloco }}
                </span>
                <span class="filter-results-count" *ngIf="rawParkings.length > 0">
                    {{ 'CUSTOMER_PAGE.SHOWING_PARKINGS' | transloco: { count: parkings.length, total: rawParkings.length
                    } }}
                </span>
            </div>

            <div class="filter-chips-grid">
                <button type="button" *ngFor="let criteria of filterCriteriaList" class="filter-chip"
                    [class.active]="optionsFilter[criteria.name]" (click)="toggleOptionFilter(criteria.name)">
                    <mat-icon class="chip-icon">{{ getCriteriaIcon(criteria) }}</mat-icon>
                    {{ criteria.translationLabel | transloco }}
                    <mat-icon class="chip-check" *ngIf="optionsFilter[criteria.name]">check</mat-icon>
                </button>

                <button type="button" class="btn-clear-filters" *ngIf="hasActiveFilters" (click)="clearAllFilters()">
                    Clear all filters
                </button>
            </div>
        </div>

        <!-- Loading State -->
        <div *ngIf="isLoading" class="loading-state-box">
            <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
            <p>Searching for available parkings...</p>
        </div>

        <!-- No Results State -->
        <div *ngIf="!isLoading && parkings.length === 0" class="no-results-box">
            <mat-icon class="no-res-icon">search_off</mat-icon>
            <h3>No parkings found</h3>
            <p>Unfortunately, no parkings match your selected criteria and dates.</p>
            <!-- <button type="button" *ngIf="hasActiveFilters" (click)="clearAllFilters()"
                class="btn-modify-search mb-2">Clear filters</button>
            <a routerLink="/customer-portal" class="btn-modify-search">Modify search</a> -->
        </div>

        <!-- Parking Cards Grid (Using pf-parking-card) -->
        <div *ngIf="!isLoading && parkings.length > 0" class="parkings-grid">
            <pf-parking-card *ngFor="let item of parkings" [parkingCardInfo]="item" [parkingDetails]="item.features"
                [parkingDays]="item.nrOfDays" (btnClick)="selectParking(item)">
            </pf-parking-card>
        </div>
    </div>

    <!-- Transfer Option Modal for Quality / Aiden -->
    <div class="modal-backdrop" *ngIf="showTransferModal" (click)="closeTransferModal()">
        <div class="modal-card" (click)="$event.stopPropagation()">
            <div class="modal-icon-badge">
                <mat-icon>airport_shuttle</mat-icon>
            </div>
            <h3 class="modal-title">Include Shuttle Transfer?</h3>
            <p class="modal-subtitle">Would you like to include airport shuttle transfers with your parking booking?</p>
            <div class="modal-actions">
                <button type="button" class="btn-modal-secondary" (click)="confirmTransferSelection(false)">
                    <mat-icon>local_parking</mat-icon>
                    No, parking only
                </button>
                <button type="button" class="btn-modal-primary" (click)="confirmTransferSelection(true)">
                    <mat-icon>directions_bus</mat-icon>
                    Yes, include transfers
                </button>
            </div>
        </div>
    </div>
</div>